<template>
    <div id="catalog-page">
        <div v-if="currentCatalogTopAd" v-on:click="handleAdClick(currentCatalogTopAd)" class="header-banner">
            <img :src="currentCatalogTopAd.imageBanner | optimizeBanner" alt="">
        </div>
        <div v-if="currentCatalogTopAd" v-on:click="handleAdClick(currentCatalogTopAd)" class="header-banner-mobile">
            <img :src="currentCatalogTopAd.imageBannerMobile | optimizeBanner" alt="">
        </div>
        <div id="filters" v-bind:class="{ 'filters-hidden': isMobile }" class="filters-wrap left-col">
            <div class="filters-wines-count" v-if="showFilters" v-on:click="toggleFiltersVisibility()">
                {{ filteredSearch(wines).length }}
                <img src="../assets/wines/wine-placeholder.png">
            </div>
            <!-- NOTA FLEIRRI TEGUNDIR SEINNA -->
            <!-- <div class="single-filter-wrap">
                <h1>Tegundir</h1>
                <div class="half-col types-col">
                    <div v-on:click="toggleFilter('type','red')" id="filter-red" class="type-wrap unactive-filter">
                        <p class="type-text">Rauðvín</p>
                    </div>
                    <div v-on:click="toggleFilter('type','white')" id="filter-white" class="type-wrap unactive-filter">
                        <p class="type-text">Hvítvín</p>
                    </div>
                    <div v-on:click="toggleFilter('type','boxwine')" id="filter-boxwine" class="type-wrap unactive-filter">
                        <p class="type-text">Kassavín</p>
                    </div>
                </div>
                <div class="half-col types-col">
                    <div v-on:click="toggleFilter('type','portwine')" id="filter-portwine" class="type-wrap unactive-filter">
                        <p class="type-text">Púrtvín</p>
                    </div>
                </div>
                <div class="types-col">
                <div v-on:click="toggleFilter('type','other')" id="filter-other" class="type-wrap unactive-filter">
                    <p class="type-text">Annað</p>
                </div>
                </div>
            </div> -->
            <div v-on:click="toggleFiltersVisibility()" v-if="isMobile" class="mobile-filter-button">Sjá valin vín</div>
            <div class="single-filter-wrap">
                <h1>Tegundir</h1>
                <div class="types-col">
                    <div v-on:click="toggleFilter('type','red')" id="filter-red" class="type-wrap unactive-filter">
                        <p class="type-text">Rauðvín</p>
                    </div>
                </div>
                <div class="types-col">
                    <div v-on:click="toggleFilter('type','white')" id="filter-white" class="type-wrap unactive-filter">
                        <p class="type-text">Hvítvín</p>
                    </div>
                </div>
                <div class="types-col">
                    <div v-on:click="toggleFilter('type','sparkling')" id="filter-sparkling" class="type-wrap unactive-filter">
                        <p class="type-text">Freyðivín</p>
                    </div>
                </div>
                <div class="types-col">
                    <div v-on:click="toggleFilter('type','rose')" id="filter-rose" class="type-wrap unactive-filter">
                        <p class="type-text">Rósavín</p>
                    </div>
                </div>
                <!-- NOTA KASSAVÍN SEINNA -->
                <!--<div class="types-col">
                    <div v-on:click="toggleFilter('type','boxwine')" id="filter-boxwine" class="type-wrap unactive-filter">
                        <p class="type-text">Kassavín</p>
                    </div>
                </div> -->
            </div>
            <div class="single-filter-wrap ratings-col">
                <h1>Einkunnir</h1>
                <div v-on:click="toggleFilter('rating','9')" id="filter-9" class="rating-wrap unactive-filter">
                    <div class="rating-marg">
                        <p class="rating-rating">9.0+</p><p class="rating-text">Framúrskarandi kaup</p>
                    </div>
                </div>
                <div v-on:click="toggleFilter('rating','8')" id="filter-8" class="rating-wrap unactive-filter">
                    <div class="rating-marg">
                        <p class="rating-rating">8-9</p><p class="rating-text">Mjög góð kaup</p>
                    </div>
                </div>
                <div v-on:click="toggleFilter('rating','7')" id="filter-7" class="rating-wrap unactive-filter">
                    <div class="rating-marg">
                        <p class="rating-rating">7-8</p><p class="rating-text">Góð kaup</p>
                    </div>
                </div>
                <div v-on:click="toggleFilter('rating','5')" id="filter-5" class="rating-wrap unactive-filter">
                    <div class="rating-marg">
                        <p class="rating-rating">5-7</p><p class="rating-text">Sæmileg kaup</p>
                    </div>
                </div>
            </div>

            <div class="single-filter-wrap price-slider-wrap">
                <h1>Verð</h1>
                <div class="price-slider-values">
                    <div class="price-slider-values-lower">{{minRange}} kr.</div>
                    <div class="price-slider-values-upper">{{maxRange}} kr.</div>
                </div>
                <div id="price-slider" ref="slider"></div> 
            </div>

            <div v-if="showAllCategories" class="single-filter-wrap">
                <h1>Flokkar</h1>
                <div v-for="category in getFoodCategories()" :key="category.id" v-on:click="toggleFilter('categories',category.string)" :id="'filter-'+category.string" v-bind:class="[filters.categories.includes(category.string) ? 'active-filter' : 'unactive-filter']" class="category-wrap">
                    <p class="type-text">{{ category.name }}</p>
                </div>
                <div v-on:click="toggleCategories" class="show-more-button">{{showMoreCategoriesButton}}</div>
            </div>
            <div v-else class="single-filter-wrap">
                <h1>Flokkar</h1>
                <div v-for="category in getFoodCategories(categoriesToShow)" :key="category.id" v-on:click="toggleFilter('categories',category.string)" :id="'filter-'+category.string" v-bind:class="[filters.categories.includes(category.string) ? 'active-filter' : 'unactive-filter']" class="category-wrap">
                    <p class="type-text">{{ category.name }}</p>
                </div>
                <div v-on:click="toggleCategories" class="show-more-button">{{showMoreCategoriesButton}}</div>
            </div>
            <div class="single-filter-wrap extras-col">
                <h1>Annað</h1>
                <div v-for="category in getOtherCategories()" :key="category.id" v-on:click="toggleFilter('categories',category.string)" :id="'filter-'+category.string" class="category-wrap unactive-filter">
                    <p class="type-text">{{ category.name }}</p>
                </div>
            </div>
            <div class="single-filter-wrap countries-col">
                <h1>Land</h1>
                <div v-for="country in sortAlphabetically(countries)" :key="country.id" v-on:click="toggleFilter('countries',[country.name, country.string])" :id="'filter-'+country.string" class="category-wrap unactive-filter">
                    <p class="type-text"><span><img class="country-icon" :src="country.icon" alt=""></span>{{ country.name }}</p>
                </div>
                <div v-on:click="toggleFilter('countries', ['other', 'other'])" :id="'filter-other'" class="category-wrap unactive-filter">
                    <p class="type-text">Annað</p>
                </div>
            </div>
            <div class="single-filter-wrap grapes-col">
                <h1>Þrúgur</h1>
                <div v-for="(grape, index) in sortAlphabetically(grapes)" :key="grape.string" v-on:click="toggleFilter('grapes', {name: grape.name, string: grape.string})" :id="'filter-'+grape.string" class="category-wrap" v-bind:class="[index+1 <= grapesShown ? '' : 'hidden-filter', filters.grapes.includes(grape.name) ? 'active-filter' : 'unactive-filter']">
                    <p class="type-text">{{ grape.name }}</p>
                </div>
                <div v-on:click="toggleFilter('grapes', {name: 'Annað', string: 'annad'})" :id="'filter-annad'" class="category-wrap unactive-filter">
                    <p class="type-text show-more-button">Annað</p>
                </div>
                <div class="show-more-button" v-if="grapesShown == minGrapesToShow" v-on:click="toggleGrapesToShow()">Sjá meira</div>
                <div class="show-more-button" v-else v-on:click="toggleGrapesToShow()">Sjá minna</div>
            </div>
            <div v-on:click="toggleFiltersVisibility()" v-if="isMobile" class="mobile-filter-button">Sjá valin vín</div>
        </div>
        <div class="right-col">
            <div class="search-wrap">
                <div class="search-bar"><input class="search-bar-input" v-model="filters.search" placeholder="Leita.."></div>
                <!-- <div class="search-button"><div class="search-button-text">Leita</div></div> -->
            </div>
            <div class="sort-by-wrap">
                <div class="sort-by">
                    <!--<p>Raða eftir</p>
                    <div class="sort-by-button" v-on:click="sortByName=true;sortByPrice=false" v-bind:class="{ 'active-sort': sortByName }">Nafni</div>
                    <div class="sort-by-button" v-on:click="sortByName=false;sortByPrice=true" v-bind:class="{ 'active-sort': sortByPrice }">Verði</div> -->
                    <select v-model="activeSort">
                        <option v-for="sort in sortBy" :key="sort.label" :value="sort.value">{{ sort.label }}</option>
                    </select>
                </div>
            </div>
            <div v-if="isMobile" class="mobile-filter-buttons-wrap">
                <div v-on:click="toggleFiltersVisibility()" v-if="isMobile" class="mobile-filter-button">Ítarleg leit</div>
            </div>
            <div class="list-wrap" v-if="filteredSearch(wines, activeSort).length">
                <div v-for="wine in filteredSearch(wines, activeSort).slice(0, winesToShow)" :key="wine.name" class="item-wrap">
                    <router-link :to="{ name: 'wine-info-page', params: {wineID: wine.id} }">
                        <div class="item-image-wrap">
                            <img v-if="wine.image != ''" :src="wine.image | optimizeWine" class="item-image"/>
                            <img v-else src="../assets/wines/wine-placeholder.png" class="item-image"/>
                        </div>
                        <div class="item-content-wrap">

                                <div class="item-title">{{ wine.name }}</div><!-- {{wine.grapes}} -->
                            
                            <!-- <div class="item-description">{{ wine.description }}</div> -->
                            <div class="item-description"><span><img class="country-icon-less" :src="getCountryIcon(wine)" alt=""></span>{{ wine.country }}</div>
                            <div class="item-description">Verð í Vínbúð: {{ wine.price1 }}kr</div>
                            <div class="item-rating">{{ wine.rating }}</div>
                            <div v-if="isWineOfTheMonth(wine)" class="item-wotm">Vín Mánaðarins</div>
                        </div>
                    </router-link>
                </div> 
                <div class="item-wrap item-full-width" v-if="winesToShow < filteredSearch(wines, activeSort).length">
                    <div class="item-more" v-on:click="loadMoreWines">
                        Sjá fleiri vín
                    </div>
                </div> 
            </div>    
            <div class="list-wrap" v-else>
                <h1>Því miður fundum við ekki það sem þú ert að leita að. Reyndu aftur!</h1>
            </div>          
        </div>
        <!-- <div class="footer-banner-cat">
            <img src="https://via.placeholder.com/1150x141/b33b3b" alt="">
        </div>
        <div class="footer-banner-mobile">
            <img src="https://via.placeholder.com/354x98/b33b3b" alt="">
        </div> -->
        <div id="scroll-top" v-on:click="scrollToTop"><img src="../assets/icons/up-arrow.png" alt=""></div>
        
    </div>
</template>

<script>
import { mapState } from 'vuex'
import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';
import $ from 'jquery'
const fb = require('../firebaseConfig.js')

$('.class')



export default {
    data() {
        return {
            wine: {
                name: '',
                description: '',
                img: null,
                area: '',
                grapes: '',
                percentage: '',
                price1: '',
                price2: '',
                producer: '',
                rating: '',
                url: ''    
            },
            filters: {
                types: [],
                ratings: [],
                categories: [],
                countries: [],
                grapes: [],
                search: ""
            },
            currentWine: null,
            categoriesToShow: 7,
            foodCategoriesMaxIndex: 22,
            showAllCategories: true,
            showMoreCategoriesButton: "Sjá meira",
            winesToShow: 20,
            winesToAdd: 20,
            minGrapesToShow: 7,
            grapesShown: 7,
            minRange: null,
            maxRange: null,
            slider: {
                startMin: 0,
                startMax: 25000,
                min: 0,
                max: 25000,
                start: 40,
                step: 100
            },
            isMobile: false,
            showFilters: false,
            grapesX: [
                {name: 'Cabernet Frac', string: 'cabernet-franc'},
                {name: 'Cabernet Sauvignon', string: 'cabernet-sauvignon'},
                {name: 'Carmenere', string: 'carmenere'},
                {name: 'Chardonnay', string: 'chardonnay'},
                {name: 'Corvina', string: 'corvina'},
                {name: 'Grenache', string: 'grenache'},
                {name: 'Malbec', string: 'malbec'},
                {name: 'Merlot', string: 'merlot'},
                {name: 'Pinot Grigio', string: 'pinot-grigio'},
                {name: 'Pinot Gris', string: 'pinot-gris'},
                {name: 'Pinot Noir', string: 'pinot-noir'},
                {name: 'Primitivo', string: 'primitivo'},
                {name: 'Riesling', string: 'riesling'},
                {name: 'Sangiovese', string: 'sangiovese'},
                {name: 'Sauvignon Blanc', string: 'sauvignon-blanc'},
                {name: 'Shiraz/Syrah', string: 'shiraz-syrah'},
                {name: 'Tempranillo', string: 'tempranillo'},
                {name: 'Zinfandel', string: 'zinfandel'},
                {name: 'Annað', string: 'annad'}
            ],
            activeSort: 0,
            sortBy: [
                 { label: 'Raða eftir', status: true, value: 0},
                 { label: 'Einkunn', status: false, value: 1 },
                 { label: 'a - Z', status: false, value: 2 },
                 { label: 'Z - a', status: false, value: 3 },
                 { label: 'Hæsta verð', status: false, value: 4 },
                 { label: 'Lægsta verð', status: false, value: 5 }
            ],
            randomSort: []

        }
    },
    props: {
        refCategory: String
    },
    watch: {
        refCategory: function() {
            this.filters.categories.forEach(category => {
                this.toggleFilter('categories', category)
            })
            this.addRefCategory()

        }
    },
    mounted() {
        this.toggleCategories()
        this.addRefCategory()
        noUiSlider.create(this.$refs.slider, {
            start: [this.slider.startMin, this.slider.startMax],
            step: this.slider.step,
            range: {
                'min': this.slider.min,
                'max': this.slider.max
            }
        }); 
                
        this.$refs.slider.noUiSlider.on('update',(values, handle) => {
            this[handle ? 'maxRange' : 'minRange'] = parseInt(values[handle]);
        }); 
    },
    methods: {
        updateSlider: function updateSlider() {
            this.$refs.slider.noUiSlider.set([this.minRange, this.maxRange]);
        },
        toggleCategories() {
            if (this.showAllCategories) {
                this.showAllCategories = false,
                this.showMoreCategoriesButton = "Sjá meira"
            } else {
                this.showAllCategories = true,
                this.showMoreCategoriesButton = "Sjá minna"
            }
        },
        addRefCategory() {
            if (this.refCategory) {
                this.toggleCategories()
                this.toggleFilter("categories", this.refCategory)
            }
        },
        toggleFilter: function(arr, filter) {
            var index
            var oldActive
            this.winesToShow = this.winesToAdd
            if (arr == "type") {
               if (this.filters.types.includes(filter)) {
                    index = this.filters.types.indexOf(filter)
                    this.filters.types.splice(index, 1)
                } else {
                    this.filters.types = []
                    this.filters.types.push(filter)
                    oldActive = document.querySelector(".types-col .active-filter")
                    if (oldActive) {
                        
                        oldActive.classList.toggle("active-filter")
                        oldActive.classList.toggle("unactive-filter")
                    }
                } 
                document.getElementById("filter-"+filter.toLowerCase()).classList.toggle("active-filter")
                document.getElementById("filter-"+filter.toLowerCase()).classList.toggle("unactive-filter")
            } else if (arr == "rating") {
                if (this.filters.ratings.includes(filter)) {
                    index = this.filters.ratings.indexOf(filter)
                    this.filters.ratings.splice(index, 1)
                } else {
                    this.filters.ratings.push(filter)
                } 
                document.getElementById("filter-"+filter.toLowerCase()).classList.toggle("active-filter")
                document.getElementById("filter-"+filter.toLowerCase()).classList.toggle("unactive-filter")
            } else if (arr == "categories") {
                /* last minute quickfix for launch */
                /* Later: Move some categories to a different filter and only allow one selected at a time */
                var extra = this.getOtherCategories()
                var isExtra = false
                var oldString = ""

                extra.forEach(cat => {
                    if (cat.string == filter) {
                        isExtra = true
                    }
                    if (this.filters.categories.includes(cat.string)) {
                        oldString = cat.string
                    }
                });
                if (isExtra) {
                    if (this.filters.categories.includes(filter)) {
                        index = this.filters.categories.indexOf(filter[0])
                        this.filters.categories.splice(index, 1)
                    } else {
                        if (oldString) {
                            index = this.filters.categories.indexOf(oldString)
                            this.filters.categories.splice(index, 1)
                        }
                        this.filters.categories.push(filter)
                        oldActive = document.querySelector(".extras-col .active-filter")
                        if (oldActive) {
                            oldActive.classList.toggle("active-filter")
                            oldActive.classList.toggle("unactive-filter")
                        }
                    }
                    
                } else {
                    if (this.filters.categories.includes(filter)) {
                        index = this.filters.categories.indexOf(filter)
                        this.filters.categories.splice(index, 1)
                    } else {
                        this.filters.categories.push(filter)
                    }
                }
                document.getElementById("filter-"+filter.toLowerCase()).classList.toggle("active-filter")
                document.getElementById("filter-"+filter.toLowerCase()).classList.toggle("unactive-filter")

                
            } else if (arr == "countries") {
                if (this.filters.countries.includes(filter[0])) {
                    index = this.filters.countries.indexOf(filter[0])
                    this.filters.countries.splice(index, 1)
                } else {
                    this.filters.countries = []
                    this.filters.countries.push(filter[0])
                    oldActive = document.querySelector(".countries-col .active-filter")
                    if (oldActive) {
                        oldActive.classList.toggle("active-filter")
                        oldActive.classList.toggle("unactive-filter")
                    }
                }
                document.getElementById("filter-"+filter[1].toLowerCase()).classList.toggle("active-filter")
                document.getElementById("filter-"+filter[1].toLowerCase()).classList.toggle("unactive-filter")
            } else if (arr == "grapes") {
                var name = filter.name
                var string = filter.string
                if (this.filters.grapes.includes(name)) {
                    index = this.filters.grapes.indexOf(name)
                    this.filters.grapes.splice(index, 1)
                } else {
                    this.filters.grapes.push(name)
                }
                document.getElementById("filter-"+string.toLowerCase()).classList.toggle("active-filter")
                document.getElementById("filter-"+string.toLowerCase()).classList.toggle("unactive-filter")
            }
        },
        filteredSearch: function(array, sort=0) {
            var visibleWines = []
            array.forEach(wine => {
                if (wine.visibility) {
                    visibleWines.push(wine)
                }
            });
            array = visibleWines

            /* if (!this.filters.search.length && !this.filters.types.length && !this.filters.ratings.length && !this.filters.categories.length) {
                return array
            } */
            var newArray = []
            array.forEach(wine => {
                var isSearch
                var isRating
                var isType
                var isCategory
                var isExtraCategory
                var isPrice
                var isCountry
                var isGrape
                
                if (this.filters.search.length) {
                    isSearch = false
                } else {
                    isSearch = true
                }

                if (this.filters.ratings.length) {
                    isRating = false
                } else {
                    isRating = true
                }

                if (this.filters.types.length) {
                    isType = false
                } else {
                    isType = true
                }

                /* if (this.filters.categories.length) {
                    isCategory = false
                } else {
                    isCategory = true
                } */

                var cats = this.getCategories()
                var catsCount = 0
                cats.forEach(cat => {
                    if (this.filters.categories.includes(cat.string)) {
                        catsCount++
                    }
                })

                if (catsCount) {
                    isCategory = false
                } else {
                    isCategory = true
                }

                var otherCats = this.getOtherCategories()
                var otherCatsCount = 0
                otherCats.forEach(cat => {
                    if (this.filters.categories.includes(cat.string)) {
                        otherCatsCount++
                    }
                });

                if (otherCatsCount) {
                    isExtraCategory = false
                } else {
                    isExtraCategory = true
                }

                if (this.filters.countries.length) {
                    isCountry = false
                } else {
                    isCountry = true
                }

                if (this.filters.grapes.length) {
                    isGrape = false
                } else {
                    isGrape = true
                }

                // CHECK IF SEARCH FILTER MATCHES
                /* let wine_name = this.replaceSpecialChars(wine.name).toLowerCase()
                let search_name = this.replaceSpecialChars(this.filters.search).toLowerCase()
                if (wine_name.includes(search_name)) {
                    isSearch = true
                } */
                if (wine.name.toLowerCase().includes(this.filters.search.toLowerCase())) {
                    isSearch = true
                }

                // CHECK IF RATING FILTERS MATCH
                /* if (this.filters.ratings.includes(wine.rating.toString())) {
                    isRating = true
                }  */
                // Replace , with . in rating to compare
                var readableRating = wine.rating.toString()
                readableRating = readableRating.replace(",", ".")
                readableRating = parseFloat(readableRating).toFixed(1)
                
                this.filters.ratings.forEach(rating => {
                    if (rating == 5) {
                        if (readableRating >= 5 && readableRating <= 7) {
                            isRating = true
                        }
                    }
                    if (rating == 7) {
                        if (readableRating >= 7 && readableRating <= 8) {
                            isRating = true
                        }
                    }
                    if (rating == 8) {
                        if (readableRating >= 8 && readableRating <= 9) {
                            isRating = true
                        }
                    }
                    if (rating == 9) {
                        if (readableRating >= 9) {
                            isRating = true
                        }
                    }
                });

                // If rating is higher than selected rating -> show wine
                /* if (readableRating >= this.filters.ratings[0]) {
                    isRating = true
                } */

                // CHECK IF TYPES FILTERS MATCH
                if (this.filters.types.includes(wine.type)) {
                    isType = true
                }

                // CHECK IF PRICE FILTER MATCHES
                if (this.minRange <= parseInt(wine.price1) && this.maxRange >= parseInt(wine.price1)) {
                    isPrice = true
                }

                // CHECK IF CATEGORIES FILTERS MATCH
                var selectedCategoryIds = []
                var selectedExtraCategoryIds = []

                this.getCategories().forEach(cat => {
                    if (this.filters.categories.includes(cat.string)) {
                        selectedCategoryIds.push(cat.id)
                    }
                })

                this.getOtherCategories().forEach(cat => {
                    if (this.filters.categories.includes(cat.string)) {
                        selectedExtraCategoryIds.push(cat.id)
                    }
                })
                wine.categories.forEach(cat => {
                    if (selectedCategoryIds.includes(cat)) {
                        isCategory = true
                    }
                })
                wine.categories.forEach(cat => {
                    if (selectedExtraCategoryIds.includes(cat)) {
                        isExtraCategory = true
                    }

                })
                

                // CHECK IF COUNTRY FILTERS MATCH
                if (this.filters.countries.includes('other')) {
                    var includes = false
                    this.countries.forEach(country => {
                        if (wine.country == country.name) {
                            includes = true
                        }
                    })
                    if (includes == false) {
                        isCountry = true
                    }
                }
                if (this.filters.countries.includes(wine.country)) {
                    isCountry = true
                }

                // CHECK IF GRAPE FILTERS MATCH
                this.filters.grapes.forEach(grape => {
                    if (wine.grapes.includes(grape)) {
                        isGrape = true
                    }
                });

                // CHECK IF 'ANNAÐ' GRAPE IS SELECTED AND WINE HAS NO VALID GRAPES
                var other = "Annað"
                var hasExistingGrape = false
                this.grapes.forEach(grape => {
                    if (wine.grapes.includes(grape.name)) {
                        hasExistingGrape = true
                    }
                })
                if (hasExistingGrape == false && this.filters.grapes.includes(other)) {
                    isGrape = true
                }

                // CHECK IF WINE MATCHES ALL FILTERS
                if (isSearch && isType && isRating && isCategory && isExtraCategory && isPrice && isCountry && isGrape) {
                    newArray.push(wine)
                }
            });
            if (sort == 0) {
                newArray.sort((a, b) => {
                    if ("dateCreated" in a ) {
                        if ("dateCreated" in b) {
                            if (a.dateCreated < b.dateCreated) {
                                return 1
                            } else {
                                return -1
                            }
                        } else {
                            return -1
                        }
                    } else {
                        if ("dateCreated" in b) {
                            return 1
                        } else {
                            if (a.price < b.price) {
                                return -1
                            } else {
                                return 1
                            }
                        }
                        
                    }
                })
            } else if (sort == 1) {
                newArray.sort((a, b) => (b.rating > a.rating) ? 1 : -1)
            } else if (sort == 2) {
                newArray.sort((a, b) => (a.name > b.name) ? 1 : -1)
            } else if (sort == 3) {
                newArray.sort((a, b) => (b.name > a.name) ? 1 : -1)
            } else if (sort == 4) {
                newArray.sort((a, b) => (parseInt(b.price1) > parseInt(a.price1)) ? 1 : -1)
            } else {
                newArray.sort((a, b) => (parseInt(a.price1) > parseInt(b.price1)) ? 1 : -1)
            }
            return newArray
        },
        getFoodCategories(catsToShow=this.foodCategoriesMaxIndex) {
            var newArray = []
            for (let index = 0; index < catsToShow; index++) {
                var category = this.categories[index]
                if (category) {
                    if (category.nr < this.foodCategoriesMaxIndex) {
                        newArray.push(this.categories[index])
                    }
                }
            }
            return newArray
        },  
        getCategories() {
            var newArray = []
            for (let index = 0; index < this.foodCategoriesMaxIndex-1; index++) {
                var category = this.categories[index]
                if (category) {
                    newArray.push(this.categories[index])
                }
            }
            return newArray
        },
        getOtherCategories() {
            var newArray = []
            for (let index = this.foodCategoriesMaxIndex-1; index < 40; index++) {
                var category = this.categories[index]
                if (category) {
                    newArray.push(this.categories[index])
                }
            }
            return newArray
        },
        isWineOfTheMonth(wine) {
            var wotm = {}
            var currentMonth = new Date().getMonth()
            var currentYear = new Date().getFullYear()
            for (let index = 0; index < this.months.length; index++) {
                if (this.months[index].month == currentMonth+1 && this.months[index].year == currentYear) {
                    wotm = this.months[index].wineid
                }
            }
            if (wine.id == wotm) {
                return true
            }
            return false
        },
        toggleFiltersVisibility() {
            if (this.showFilters) {
                this.showFilters = false
                document.getElementById('filters').classList.add('filters-hidden')
                document.getElementsByClassName('list-wrap')[0].classList.remove('zero-height')
                window.scrollTo(0, 0);
            } else {
                this.showFilters = true
                document.getElementById('filters').classList.remove('filters-hidden')
                document.getElementsByClassName('list-wrap')[0].classList.add('zero-height')
            }
        },
        sortAlphabetically(list) {
            var listCopy = list.slice()
            listCopy.sort(function(a, b) {
                var item1 = a.name
                var item2 = b.name
                return (item1 < item2) ? -1: (item1 > item2) ? 1 : 0
            })
            return listCopy
        },
        loadMoreWines() {
            this.winesToShow += this.winesToAdd
        },
        scrollToTop() {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        },
        getCountryIcon(wine) {
            for (let i = 0; i < this.countries.length; i++) {
                const e = this.countries[i];
                if (e.name == wine.country) {
                    return e.icon
                }
            }
            return null
        },
        toggleGrapesToShow() {
            if (this.grapesShown == this.minGrapesToShow ) {
                this.grapesShown = this.grapes.length
            } else {
                this.grapesShown = this.minGrapesToShow
            }
        },
        handleAdClick(ad) {
            window.open(ad.url)
            fb.db.collection("ads").doc(ad.id).update({
                clicks: ad.clicks + 1,
            })
        },
        /* replaceSpecialChars(string) {
            var withDia = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
            var withoutDia = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
            //string = "sólskin";
            for (let i = 0; i < string.length; i++) {
                if (withDia.includes(string[i])) {
                    let index = withDia.indexOf(string[i])
                    string = string.replace(string[i], withoutDia[index])
                }
            }
            // replaceAll not supported on safari
            // for (let i = 0; i < withDia.length; i++) {      
            //    string = string.replaceAll(withDia[i], withoutDia[i]);
            //} 
            console.log(string)
            return string
        } */
    },
    computed: {
        ...mapState(['wines', 'categories', 'months', 'countries', 'grapes', 'currentCatalogTopAd'])
    },
    created: function() {
        if (window.innerWidth <= 768) {
            this.isMobile = true
        }
    },
    filters: {
        optimizeWine: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_300/')
            return newUrl
        },
        optimizeBanner: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto/')
            return newUrl
        }
    }

    
}
</script>

<style>
@media only screen and (max-width: 768px) {
    .item-wrap {
        width: 100%;
    }
    .left-col {
        width:100%;
    }
    .right-col {
        padding-top: 2rem;
        width:100%;
    }
    .list-wrap {
        margin: 0;
    }
    .single-filter-wrap {
        width: 100%;
    }
    .rating-marg {
        
    }
    .rating-wrap {
        width:100%;
        display:inline-block;
        padding: 0;
        margin-left: 5px;
        margin-right: 5px;
    }
    .category-wrap {
        height: 35px !important;
        line-height: 35px;
        
    }
    .category-wrap p {
        font-size: 20px !important;
    }
    .filters-hidden {
        margin-top: -9999px;
        
        padding: 0 !important;
    }
    .mobile-filter-buttons-wrap {
        clear:both;
        height: 60px;
        width: 100%;
        
    }
    .mobile-filter-button {
        width:100%;
        height:40px;
        background-color: #b33b3b;
        margin:auto;
        cursor: pointer;
        font-size: 22px;
        color: white;
        line-height: 40px;
    }
    .filters-wrap {
        position: absolute;
        top: 0;
        left: 0;
        background-color: white;
        z-index: 100;
        width: 100vw;
        overflow-x: hidden;
        overflow-y: scroll;
        /* transition: 0.5s; */
        padding: 0 !important;
    }
    .single-filter-wrap {
        position: relative;
        width:90%;
        margin: auto;
    }
    .price-slider-wrap {
        width:80%;
        margin:auto;
    }
    .category-wrap {
        
        
    }
    .filters-wines-count {
        position: fixed;
        bottom: 0;
        font-size: 24px;
        right:0;
        margin-right: 10px;
        margin-bottom: 10px;
        background-color: #b33b3b;
        border-radius: 5px;
        height:38px;
        width:60px;
        color:white;
        -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
        box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
        z-index: 100;
    }
    .filters-wines-count img {
        height: 20px;
        width: 5px;
        margin-top: 0px;
        margin-left: 5px;
        filter: brightness(0) invert(1);
    }
    .search-wrap {
        width:50%;
    }
    .search-bar-input {
        width:80%;
        text-align: left;
        font-size: 16px;
    }
    .sort-by-wrap {
        width: 50%;
        right: 0;
        float: right;
    }
    #scroll-top {
        width: 50px;
        height: 50px;
        bottom: 20px;
        right: 10px;
    }
    #scroll-top img {
        width: 24px;
        height: 24px;
        margin-left: 0px;
        margin-top: 12px;
    }

}

@media only screen and (min-width: 769px) {
    .item-wrap {
        width: 46%;
    }
    .left-col {
        width:25%;
        float: left;
    }
    .right-col {
        width:72%;
        float:left;
        padding-left: 3%;
    }
    .list-wrap {

    }
    .single-filter-wrap {
        width: 90%;
    }
    .search-wrap {
        margin-top:2rem;
        width: 75%;
    }
    .search-bar-input {
        width:95%;
        text-align: center;
        font-size: 26px;
    }
    .rating-wrap {
        padding: 1px 0;
        margin: 0 5px;
    }
    .type-wrap:hover {
        background-color: #d17076;
    }
    .rating-wrap:hover {
        background-color: #d17076;
    }
    .category-wrap:hover {
        background-color: #d17076;
    }
    .filters-wines-count {
        display: none;
    }
    .sort-by-wrap {
        width: 25%;
        float:left;
        margin-top: 2rem;
    }
    #scroll-top {
        width: 40px;
        height: 40px;
        bottom: 20px;
        right: 7px;
    }
    #scroll-top img {
        width: 20px;
        height: 20px;
        margin-left: 0px;
        margin-top: 10px;
    }
}

@media only screen and (min-width: 1200px) {
    #scroll-top {
        width: 50px;
        height: 50px;
        bottom: 40px;
        right: 15%;
    }
    #scroll-top img {
        width: 24px;
        height: 24px;
        margin-left: 0px;
        margin-top: 12px;
    }
}

.item-more {
    font-size: 26px;
    color: #b33b3b;
    line-height: 50px;
}
.item-full-width {
    width: 100%;
    height: 50px !important;
}
#scroll-top {
    position: fixed;
    background-color: white;
    border-radius: 30px;
    cursor: pointer;
    box-shadow: 0 1px 4px #a8a5a3;
}
.active-filter {
    background-color: #B33B3B;
    color: white;
}
.unactive-filter {
    background-color: white;
    color: #B33B3B;

}
a:link, a:visited, a:hover, a:active {
    text-decoration: none;
    color: #2c3e50;
}


.filters-wrap {
    padding:2rem 0;
    box-shadow: 0 0 3 black;
}
.single-filter-wrap {
    margin-bottom: 15px;
    
}
.single-filter-wrap h1 {
    font-size: 26px;
    margin:0;
    margin-bottom: 10px;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.type-wrap {
    padding:1px;
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 0.3rem;
    cursor: pointer;
    box-shadow: 0 1px 4px #a8a5a3;
}

.type-text {
    margin: 5px 0;
    font-size: 20px;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.rating-marg {
    box-shadow: 0 1px 4px #a8a5a3;
    cursor: pointer;
}
.rating-wrap {
    position: relative;
    margin-bottom: 0.3rem;
    font-size: 20px;
}

.rating-rating {
    position: absolute;
    width:100%;
    font-size: 14px;
    margin: auto;
    margin-top: 5px;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.rating-text {
    margin-bottom: 5px;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display:inline-block;
}
.category-wrap {
    box-shadow: 0 1px 4px #a8a5a3;
    height:25px;
    margin-bottom: 5px;
    cursor: pointer;
}
.category-wrap p {
    font-size: 16px;
    margin:0;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.country-icon {
    height:15px;
    margin-right: 10px;
    margin-left: -25px;
}
.country-icon-less {
    height:15px;
    margin-right: 5px;
}
.search-wrap {
    float:left;
    height:55px; /* 100px */
}
.search-bar {
    float:left;
    height:40px; /* 60px */
    width: 100%;
    border-radius: 30px;
    background-color: white;
    box-shadow: 0 1px 4px #a8a5a3;
}
.search-bar-input {
    height:30px; /* 50px */
    border: none;
    /*font-size: 26px;*/ /* 32px */
    color: #2c3e50;
    background: transparent;
    padding:5px 20px;
}
.search-bar-input:focus {
    outline-width: 0;
}
.sort-by-wrap {
    height:50px;
    padding: 0;
}
.sort-by select {
    margin-left: 5%;
    height: 40px;
    width: 95%;
    padding: 10px;
    font-size: 16px;
    border: 0px solid rgb(245, 240, 240);
    border-radius: 30px;
    text-align: center;
    background-color: white;
    box-shadow: 0 1px 4px #a8a5a3;
}
.sort-by select:focus {
    outline: none;
}
.sort-by select option {
    width:20px;
}


.list-wrap {
    width:100%;
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.item-wrap {
    margin-bottom: 15px;
    position: relative;
    background-color: white;
    box-shadow: 0 1px 4px #a8a5a3;
    height:210px;
    border-radius: 10px;
    padding:10px;
    cursor: pointer;
}
.item-wrap:hover {
    box-shadow: 0 1px 6px #8f8c8b;
}
.item-image-wrap {
    float:left;
    height:210px;
    width:20%;
    max-width: 155px;
    min-width: 55px;
    background-color: white;
    border-radius: 10px;
}
.item-image {
    margin-top: 10%;
    max-width:100%;
    max-height:90%;
}
.item-content-wrap {
    width: 76%;
    height: 100%;
    float:left;
    text-align: left;
    position: relative;
}
.item-title {
    line-height: 28px;
    margin-left: 10px;
    font-size: 24px;
    color: #b33b3b;
}
.item-description {
    margin-left: 10px;
    font-size: 18px;
}
.item-rating {
    margin-left: 10px;
    position: absolute;
    display: block;
    font-size: 26px;
    bottom:0;
    color: #e8b923;
}
.item-wotm {
    position: absolute;
    background-color: #b33b3b;
    width:100px;
    text-align: center;
    border-radius: 5px;
    color: white;
    padding: 4px;
    right:0;
    bottom: 0;
}
.half-col {
    width:50%;
    display: inline-block;
}
.show-more-button {
    cursor: pointer;
}
.zero-height {
    height:0;
    overflow:hidden;
}
/* RANGE SLIDER */

.price-slider-values {
    display:inline-block;
    width:100%;
    padding-bottom: 20px;
}
.price-slider-values-lower {
    text-align: left;
    display:inline-block;
    width:50%;
}
.price-slider-values-upper {
    text-align: right;
    display:inline-block;
    width:50%;
}

/* #lower {
    position: absolute;
    box-sizing: border-box;
}
#upper {
    position: absolute;
    background: none;
}
.rangeslider-price-wrap {
    width:100%;
    position: relative;
    
}
.rangeslider-price-wrap input[type=range] {
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 200px;
    margin: 0;
    padding: 0 2px;
    overflow: hidden;
    border: 0;
    border-radius: 1px;
    outline: none;
    background: -webkit-gradient(linear, left top, left bottom, from(grey), to(grey)) no-repeat center;
    background: linear-gradient(grey, grey) no-repeat center;
    background-size: 100% 2px;
    pointer-events: none;
}
.rangeslider-price-wrap input[type="range" i] {
    -webkit-appearance: slider-horizontal;
    color: rgb(196, 196, 196);
    cursor: default;
    padding: initial;
    border: initial;
    margin: 2px;
}
.rangeslider-price::-webkit-slider-thumb {
      height: 28px;
      width: 28px;
      border-radius: 28px;
      background-color: #fff;
      position: relative;
      margin: 5px 0;
      cursor: pointer;
      appearance: none;
      pointer-events: all;
      box-shadow: 0 1px 4px 0.5px rgba(0, 0, 0, 0.25); 
}
.rangeslider-price input[type=range] {
    
} */
/* .rangeslider-price {
    height: 20px;
    width: 400px;
    background: #d3d3d3;
}
.rangeslider-price::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background: #bb3b3b;
  cursor: pointer;
}

.rangeslider-price::-moz-range-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background: #bb3b3b;
  cursor: pointer;
} */
.list-wrap{
    text-align: center;
}
.hidden-filter {
    height: 0px !important;
}
.hidden-filter p {
    display: none;
}
/* AD */    
.footer-banner-cat {
    margin-top: 20px;
}
.footer-banner-cat img {
    margin-top: 50px;
    width: 100%;
}
/* AD END */
</style>